export default __webpack_public_path__ + "static/media/about_icon2hover.fc260a5f.svg";